import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p3mzzb85vs: FaireBrandEntity = {
  token: "b_p3mzzb85vs",
  type: "brand",
  name: "La Cascina di Marta",
  avatarUrl:
    "https://cdn.faire.com/fastly/48b84721d998506afc4ed75530f681ef0ca6b2bda2c091cd2f90d991413db05f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e9d30e3a23e672c42eec2442bab4bb1fc2c2b1d5722e408db3551e26b59880bb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/48b84721d998506afc4ed75530f681ef0ca6b2bda2c091cd2f90d991413db05f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e9d30e3a23e672c42eec2442bab4bb1fc2c2b1d5722e408db3551e26b59880bb.jpeg",
  location: "ITA",
  minimumOrderDollars: 322,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "La Cantina di Marta was born from passion. The passion for high quality, raw materials, excellent food and wine. A careful research, not only for specialists in  food sector, but for anyone who wants the best on their table and for themselves.\nThe Cantina di Marta Team, with a long experience in direct distribution and after a long selection, is now focused on the marketing of high-end traditional food products from producers in all Italian regions.ì\nTje products are carefully selected through sensory tests and related sales surveys, to create a range of offers that can meet the needs of its business partners.\nWith La Cantina di Marta.com, our customers find a new way of discovering, buying and tasting the best specialties of the Italian territory and appreciating its history,  tradition and uniqueness.\nLa Cantina di Marta is committed to a strong investment in the entire supply chain and is always attentive to new solutions to support the omnichannel strategy, strongly convinced that this is the future of distribution.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:49.368Z",
    importedBy: "entity-db-cli",
  },
};
